module.exports = __webpack_public_path__ + "img/squalo_sport_logo-02.0a748cc2.png";